import type { ComplianceDeadline, EngineStatus, Vessel } from "@common/types";

/** Count each real service/control deadline once; forecasts do not change the count. */
export function maintenanceAttention(engines: EngineStatus[], deadlines: ComplianceDeadline[], vessels: Vessel[]): number {
  const active = new Set(vessels.filter(v => v.isActive).map(v => v.id));
  const tasks = new Set<string>();
  for (const s of engines) {
    if (!s.engine.isActive || !active.has(s.engine.vesselId)) continue;
    for (const task of s.tasks) {
      if (["due_soon", "due_now", "overdue"].includes(task.status)) tasks.add(`engine:${s.engine.id}:${task.code}`);
    }
  }
  for (const d of deadlines) {
    if (d.kind !== "equipment" || (d.vesselId && !active.has(d.vesselId))) continue;
    if (d.status === "due_soon" || d.status === "overdue" || d.completion === "deficiency") tasks.add(`equipment:${d.vesselId ?? "shared"}:${d.refId ?? d.label}`);
  }
  return tasks.size;
}
